module.exports = "<div id=mapDetailDivId class=sb-map-position></div> <ul class=sb-map-legend> <li class=sb-map-legend-marker> <img src=/assets/black-marker.png /> <span translate=MAP.LEGEND.NORMAL></span> </li> <li class=sb-map-legend-marker> <img src=/assets/red-marker.png /> <span translate=MAP.LEGEND.ALARM></span> </li> <li class=sb-map-legend-marker> <img src=/assets/green-marker.png /> <span translate=MAP.LEGEND.FIRST></span> </li> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/detail/map-position/map-position.html
// module id = 359
// module chunks = 0